import React from "react";
import Icon from "@ant-design/icons";
import plusPng from "../../../assets/Svg/+.png";
const PlusImg = () => <img src={plusPng} alt="" />;

const PlusIcon = (props) => <Icon component={PlusImg} {...props} />;

export default PlusIcon;
